import global from "global";
import { LOG_LEVEL_ERROR, LOG_LEVEL_WARN, LOG_LEVEL_INFO } from "../constants";

/**
 * Certain IE11 and Edge versions throw errors if try to console log
 * while developer tools are closed. Thus we now check if the console
 * is available.
 *
 * REF: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/14495220/
 *
 * We also can't just store the console methods in a map due to another
 * quirk of IE11 and Edge which will throw exceptions if a stored version
 * of the native function is invoked.
 *
 * REF: https://www.beyondjava.net/console-log-surprises-with-internet-explorer-11-and-edge
 */
export default (level, detail, attributes) => {
  if (global.console) {
    switch (level) {
      case LOG_LEVEL_ERROR:
        global.console.error(detail, attributes);
        break;
      case LOG_LEVEL_WARN:
        global.console.warn(detail, attributes);
        break;
      case LOG_LEVEL_INFO:
        global.console.info(detail, attributes);
        break;
    }
  }
};
